module.exports = __webpack_public_path__ + "img/t4-b2.880b5dcb.png";